import React from 'react';
import {connect} from 'react-redux';
import {fetchUser} from '../../../../../actions/entities/user';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';

const hideLeague = (userId, leagueId, hidden) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('hideLeague', userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({leagueId, hidden}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          dispatch(fetchUser({identifier: userId}));
        }
      });
  };
};

const UserLeaguesInfo = ({user, dispatch}) => {
  const renderAction = (leagueId, hidden) => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}>
      <div>Hidden</div>
      <div>
        <input
          type="checkbox"
          checked={hidden}
          onChange={() => dispatch(hideLeague(user.id, leagueId, !hidden))}
        />
      </div>
    </div>
  );

  return (
    <div>
      <SupportTitle title="Leagues" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {user.leagues.map(league => (
            <TableRow
              key={league.id}
              label={league.id.replace('mpg_league_', '')}
              value={league.name}
              action={renderAction(league.id, league.hidden)}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserLeaguesInfo);



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/LeaguesInfo/index.js